module.exports = __webpack_public_path__ + "static/media/icn_sort_numeric.b831a0a3.svg";